

















import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import ProductDescriptionSection from '~/components/molecules/ProductDescriptionSection/ProductDescriptionSection.vue';
import type { ProductDescription } from '~/types/product/ProductDescription';

export default defineComponent({
  name: 'ProductDescription',
  components: {
    ProductDescriptionSection,
  },
  props: {
    productDescription: {
      type: Object as PropType<ProductDescription>,
      default: () => {
        return {};
      },
    },
  },
});
